import { render } from "./Unauthorized.vue?vue&type=template&id=d0ae61e6&scoped=true"
const script = {}

import "./Unauthorized.vue?vue&type=style&index=0&id=d0ae61e6&lang=scss&scoped=true"

import exportComponent from "../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ae61e6"]])

export default __exports__